<script setup>
import { ref } from 'vue';
import axios from 'axios';
import { useTheme } from 'vuetify';

const isDark = ref(false);
const theme = useTheme();
const getDarkModePreference = async () => {

  // axios.get('/user/dark-mode').then(response => {
  //   isDark.value = response.data.dark_mode;
  //   document.documentElement.classList.toggle('dark', isDark.value);
  // });

  const baseURL =
    typeof window !== 'undefined'
      ? window.location.origin
      : 'https://spicycollab.com';
  if (typeof window !== 'undefined') {
    axios.get(`/user/dark-mode`).then(response => {
      isDark.value = response.data.dark_mode;
      document.documentElement.classList.toggle('dark', isDark.value);
      theme.global.name.value  = isDark.value ? 'customThemeDark' : 'customTheme';
    });
  }
};

getDarkModePreference();

const toggleDarkMode = () => {
  isDark.value = !isDark.value;
  document.documentElement.classList.toggle('dark', isDark.value);
  theme.global.name.value = isDark.value ? 'customThemeDark' : 'customTheme';
  axios
    .post('/user/update-dark-mode', { dark_mode: isDark.value })
    .then(() => {
      console.log('Dark mode preference updated.');
    })
    .catch(error => {
      console.error('Failed to update dark mode preference:', error);
    });
};
</script>

<template>
  <div
    class="relative flex items-center justify-center w-10 h-10 p-2 transition-colors duration-300 bg-blue-500 rounded-full cursor-pointer dark:bg-blue-900"
    @click="toggleDarkMode"
  >
    <i
      v-if="isDark"
      class="text-lg text-yellow-400 fas fa-moon"
    ></i>
    <i
      v-else
      class="text-lg text-orange-400 fas fa-sun"
    ></i>
  </div>
</template>

<style scoped>
  i {
    pointer-events: none;
    transition:
      transform 0.3s ease,
      opacity 0.3s ease;
  }
</style>
